import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';
import type { DeviceStatusEvent } from '@cobliteam/api-lib/src/dashboard/device/definitions/Types';

import type { UUID } from '@cobliteam/common-types';
import type { LoadDeviceStatusSuccess, LoadDevicesFailed, LoadDevicesRequest, LoadDevicesSucceeded } from './actions';
import { DevicesActionTypes } from './actionTypes';

export const loadDevicesRequest = (vehicleGroupIds?: UUID[], includeObservationPeriodTrigger?: boolean): LoadDevicesRequest => {
  return {
    type: DevicesActionTypes.LOAD_DEVICES_REQUEST,
    payload: { vehicleGroupIds, includeObservationPeriodTrigger },
  };
};

export const loadDevicesSucceeded = (drivers: DeviceFragment[]): LoadDevicesSucceeded => ({
  type: DevicesActionTypes.LOAD_DEVICES_SUCCEEDED,
  payload: drivers,
});

export const loadDevicesFailed = (): LoadDevicesFailed => ({
  type: DevicesActionTypes.LOAD_DEVICES_FAILED,
});

export const loadDeviceStatusSuccess = (payload: DeviceStatusEvent[]): LoadDeviceStatusSuccess => ({
  type: DevicesActionTypes.LOAD_DEVICE_STATUS_SUCCESS,
  payload,
});
